module.exports = __webpack_public_path__ + "static/media/bolt-download2.9181d9ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bolt-download2.png
// module id = 348
// module chunks = 0